export default "__VITE_ASSET__DEDmVGxG__"